import graphql from "utils/api/graphql";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { SCREENS } from "utils/constants";
import View from "./View";

const Replenish = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [executeFlow] = useMutation(graphql.mutations.EXECUTE_FLOW, {
    onCompleted: () => navigate(SCREENS.PRIVATE.XO.ACCOUNTS.LIST.path),
    onError: () => {},
  });

  const onSubmit = () => {
    executeFlow({
      variables: {
        where: {},
        data: {
          debtorAgent: { bic: data.debtor },
          interbankSettlementAmount: {
            currency: data.currency,
            amount: data.amount,
          },
          product: { id: "1" },
        },
      },
    });
  };

  return <View onSubmit={onSubmit} setData={setData} data={data} />;
};

export default Replenish;
